module.exports = __webpack_public_path__ + "img/37.4831421e.jpg";